import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS

export const END_USER_DEVICE_FETCH_REQUEST =
  'endUsers/END_USER_DEVICE_FETCH_REQUEST';
export const END_USER_DEVICE_FETCH_SUCCESS =
  'endUsers/END_USER_DEVICE_FETCH_SUCCESS';
export const END_USER_DEVICE_FETCH_ERROR =
  'endUsers/END_USER_DEVICE_FETCH_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case END_USER_DEVICE_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case END_USER_DEVICE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: false,
        entities: action.payload.entities.endUserDevices,
        result: action.payload.result,
      };

    case END_USER_DEVICE_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Schemas
const endUserDevicesSchema = new schema.Entity('endUserDevices');

// Operations

export function fetchEndUserDevice(params) {
  return {
    [CALL_API]: {
      types: [
        END_USER_DEVICE_FETCH_REQUEST,
        END_USER_DEVICE_FETCH_SUCCESS,
        END_USER_DEVICE_FETCH_ERROR,
      ],
      promise: (httpClient) => httpClient.post('/endUserDevice', params),
      schema: { data: [endUserDevicesSchema] },
    },
  };
}
